"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Filtr_1 = require("../../../../components/Filtr/Filtr");
var hooks_1 = require("../../../../hooks");
var BlockWithTime = function (_a) {
    var _b;
    var value = _a.value, label = _a.label, typUdalosti = _a.typUdalosti, handleChange = _a.handleChange, name = _a.name;
    var _c = hooks_1.useCiselnik(typUdalosti), data = _c.data, loading = _c.loading, error = _c.error;
    if (loading) {
        return react_1.default.createElement("div", null, "loading");
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    var typ = (_b = data === null || data === void 0 ? void 0 : data.find(function (d) { return d.id === (value === null || value === void 0 ? void 0 : value.Typ); })) === null || _b === void 0 ? void 0 : _b.nazev;
    var DatumOd = new Date((value === null || value === void 0 ? void 0 : value.Od) || '');
    var DatumDo = new Date((value === null || value === void 0 ? void 0 : value.Do) || '');
    if (handleChange && name) {
        handleChange(name, typ);
    }
    return (react_1.default.createElement("div", null,
        label,
        react_1.default.createElement("br", null),
        typ && react_1.default.createElement(Filtr_1.Filtr, null, typ),
        (value === null || value === void 0 ? void 0 : value.Od) && react_1.default.createElement(Filtr_1.Filtr, null,
            "Od: ", DatumOd.getDate() + "." + (DatumOd.getMonth() + 1) + "." + DatumOd.getFullYear()),
        (value === null || value === void 0 ? void 0 : value.Do) && react_1.default.createElement(Filtr_1.Filtr, null,
            "Do: ", DatumDo.getDate() + "." + (DatumDo.getMonth() + 1) + "." + DatumDo.getFullYear())));
};
exports.default = BlockWithTime;
